module.exports = __webpack_public_path__ + "static/media/logo_harshit.0f368988.svg";